/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_03_Detail_Amateur_0_HeadingInputs */

const en_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where the old cues came from`)
};

const es_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De dónde vinieron las viejas señales`)
};

const de_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woher die alten Hinweise kamen`)
};

const zh_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旧口令从何而来`)
};

const ar_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من أين جاءت الإشارات القديمة`)
};

const fr_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D'où viennent les vieux signaux`)
};

const vi_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các tín hiệu cũ đến từ đâu`)
};

const sw_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maelekezo ya zamani yalitoka wapi`)
};

const th_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คำแนะนำเก่ามาจากไหน`)
};

const bs_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odakle su došli stari signali`)
};

const ja_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`昔の教えはどこから来たのか`)
};

const ko_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오래된 가르침은 어디서 왔을까`)
};

const pt_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De onde vieram as velhas dicas`)
};

const it_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da dove venivano le vecchie istruzioni`)
};

const sv_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Var de gamla instruktionerna kom ifrån`)
};

const nl_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar de oude aanwijzingen vandaan kwamen`)
};

const da_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvor de gamle instruktioner kom fra`)
};

const nb_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvor de gamle instruksjonene kom fra`)
};

const fi_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistä vanhat ohjeet tulivat`)
};

const pl_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skąd wzięły się dawne wskazówki`)
};

const ru_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откуда взялись старые подсказки`)
};

const tr_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eski komutlar nereden geldi`)
};

const hi_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुरानी सलाहें कहाँ से आईं`)
};

const id_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari mana aba-aba lama berasal`)
};

const ms_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari mana datangnya isyarat lama`)
};

const cs_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkud se vzaly staré pokyny`)
};

const el_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Από πού προήλθαν οι παλιές οδηγίες`)
};

const he_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מאיפה הגיעו ההנחיות הישנות`)
};

const af_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarvandaan die ou wenke gekom het`)
};

const hu_method_content_step_03_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Honnan erednek a régi utasítások`)
};

/**
* | output |
* | --- |
* | "Where the old cues came from" |
*
* @param {Method_Content_Step_03_Detail_Amateur_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_03_detail_amateur_0_heading = /** @type {((inputs?: Method_Content_Step_03_Detail_Amateur_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_03_Detail_Amateur_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "de") return de_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "th") return th_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "it") return it_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "da") return da_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "id") return id_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "el") return el_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "he") return he_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "af") return af_method_content_step_03_detail_amateur_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_03_detail_amateur_0_heading(inputs)
	return en_method_content_step_03_detail_amateur_0_heading(inputs)
});